<template>
  <section>
    <div v-for="(gaiyo, index) in gaiyos" :key="index">
      <!--<hr v-show="index>0">-->
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">(1) 番号</div>
        <div class="gaiyo-element left-40">{{gaiyo.bango}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">(2) 種別</div>
        <div class="gaiyo-element left-40">{{gaiyo.shubetsu}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">(3) 用途</div>
        <div class="gaiyo-element left-40">{{gaiyo.yoto}} {{gaiyo.yotoNaiyo}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">(4) 積載荷重</div>
        <div class="gaiyo-element left-40">{{gaiyo.sekisaiKaju}} N</div>
        <!--<div class="gaiyo-element left-40">{{gaiyo.sekisaiKaju}} {{unitName(gaiyo.sekisaiUnit)}}</div>-->
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">(5) 最大定員</div>
        <div class="gaiyo-element left-40">{{gaiyo.saidaiTeiin}} 人</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">(6) 定格速度</div>
        <div class="gaiyo-element left-40">{{gaiyo.teikakuSokudo}} m/分</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">(7) 備考</div>
        <div class="gaiyo-element left-40">{{gaiyo.etcJiko}}</div>
        <div v-for="(n,index) in wordwrap(gaiyo.etcJiko,33)" :key="`biko1-${index}`">
          <br v-show="index>0"></div>
        <div class="gaiyo-element left-40">{{gaiyo.ninshoBango}}</div>
        <div v-for="(n,index) in wordwrap(gaiyo.ninshoBango,33)" :key="`biko2-${index}`">
          <br v-show="index>0"></div>
        <br>
      </div>
    </div>
  </section>
</template>

<script>
import { wordwrap } from '../../common/utils'
export default {
  data() {
    return {
      sekisaiUnits: [
        { code: 0, name: '不明' },
        { code: 1, name: 'kg' },
        { code: 2, name: 'N' },
      ],
    }

  },
  
  props: {
    
    gaiyos: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
  },
  methods : {
    wordwrap(text, len) {
      return wordwrap(text, len);
    },
    unitName(code) {
      try{
        const unit = this.sekisaiUnits.find(u => u.code === code);
        return unit ? unit.name : undefined; // 単位が見つからない場合はundefinedを返す
      }catch(e){
        return 0;
      }
    }
    
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/common/common.css";
@import "../../styles/gaiyo.css";
/*
.item-row {
  font-size: small;
  line-height: 1;
  margin-top: -1.2em;
  margin-bottom: -1.2em;
}
*/
.item-row {
  font-size: small;
  line-height: 1;
  //margin-top: -1.2em;
  //margin-bottom: -1.2em;
}
//
.gaiyo-section-header {
  font-size: 14pt;
}
.gaiyo-row {
  line-height: 8mm;
}
.gaiyo-major-title {
  font-size: 12pt;
}
.gaiyo-minor-title {
  font-size: 11pt;
}
.gaiyo-element {
  font-size: 11pt;
}
.left-40 {
  width: 130mm;
}
</style>